<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<ng-http-loader *ngIf="splashScreenService.spinnerEnabled"
    [backdrop]="true"
    [backgroundColor]="'#00A9A5'"
    [debounceDelay]="100"
    [extraDuration]="300"
    [minDuration]="300"
    [opacity]=".6"
    [spinner]="spinkit.skWave">
</ng-http-loader>
<router-outlet></router-outlet>
